<template>
    <div id="stakeholders-control" class="mb-4 mt-2 p-4">
        <div class="vx-row">
            <!-- {{personal_business.id}} -->
            <div class="vx-col w-full">
                <h4>Estructura accionaria</h4>
                <p>Aquí podrás gestionar la estructura accionaria de la persona moral.</p>
                <vs-divider></vs-divider>
            </div>
            <div v-if="isMounted" class="vx-col w-full">
                <vs-button :disabled="source.status >= 4" color="primary" type="border" icon-pack="feather" class="mb-4"  @click="addStakeholder()">Agregar accionista</vs-button>   
                <vs-table ref="table" pagination max-items="5" :data="stakeholdersArray"
                    noDataText="No hay datos disponibles" stripe>
                    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mt-4">
                        <h5>Lista de accionistas</h5>
                        <small>*Para PF es Fecha de nacimiento, PM es fecha de constitución.</small>
                    </div>
                    <template slot="thead">
                        <vs-th v-for="(col, idx) in columns" v-bind:key="idx"
                            :sort-key="col.sortable ? col.key : null">{{ col.title }}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data" :data="tr">
                            <vs-td>
                                <span class="bold">{{ tr.id }} | {{ stakeholderName(tr) }}</span> <br>
                                <span class="">
                                    Correo: {{ tr.email||"NA" }} <br>
                                    Tel: {{ getPhone(tr)||"--" }} <br>
                                    RFC: {{ getRFC(tr) }} <br>
                                    <vs-chip :color="personType(tr) == 'PF' ? 'primary' : 'warning'">
                                        {{ personType(tr) }}
                                    </vs-chip>
                                </span>
                            </vs-td>
                            <vs-td>
                                {{ getAddress(tr).neighborhood_id != null ?  getAddress(tr).full_address : "Dirección pendiente de llenar" }}
                            </vs-td>
                            <vs-td>
                                {{ tr.share_percentage * 10 }}
                            </vs-td>
                            <vs-td>
                                {{ getDate(tr)||"--" }}
                            </vs-td>
                            <vs-td>
                                {{ tr.guarantee_id||"--" }}
                            </vs-td>
                            <vs-td>
                                {{ isRepLegal(tr) ? "Si" : "No"}}
                            </vs-td>
                            <vs-td>
                                <vs-checkbox v-model="tr.is_guarantee" @change="receiveCallHandle(data[indextr])"></vs-checkbox>
                                <!-- <template v-if="tr.guarantee_data != null && tr.guarantee_data.length > 0">
                                    <div v-if="getGuaranteeData(tr.guarantee_data) != null">
                                        <span>GID: {{ getGuaranteeData(tr.guarantee_data) == null ? 'si' : 'no' }}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <small>No es obligado solidario</small>
                                </template> -->
                            </vs-td>
                            <vs-td v-if="!isRepLegal(tr)">
                                <div class="flex">
                                    <vx-tooltip
                                    text="Eliminar accionista">
                                        <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer" class="ml-6" @click.stop="removeItemRequest(data[indextr])" />
                                    </vx-tooltip>
                                    <vx-tooltip
                                        text="Editar accionista">
                                        <feather-icon  icon="EditIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" @click.stop="setEditForm(data[indextr])" />
                                    </vx-tooltip>
                                    <div v-if="tr.is_guarantee" class="flex">
                                        <vx-tooltip
                                            text="Enviar recordatorio de verificación de identidad solicitada.">
                                            <feather-icon  icon="UserIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(data[indextr], 1)" />
                                        </vx-tooltip>
                                        <!-- <vx-tooltip
                                            text="Enviar recordatorio de consulta cdc solicitada.">
                                            <feather-icon  icon="DollarSignIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(data[indextr], 2)" />
                                        </vx-tooltip> -->
                                    </div>
                                </div>
                            </vs-td>
                            <vs-td v-else>
                                <vx-tooltip
                                    text="Editar accionista">
                                    <feather-icon  icon="EditIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current cursor-pointer" class="ml-6" @click.stop="setEditForm(data[indextr])" />
                                </vx-tooltip>
                                <div v-if="tr.is_guarantee" class="flex">
                                    <vx-tooltip
                                        text="Enviar recordatorio de verificación de identidad solicitada.">
                                        <feather-icon  icon="UserIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(data[indextr], 1)" />
                                    </vx-tooltip>
                                    <!-- <vx-tooltip
                                        text="Enviar recordatorio de consulta cdc solicitada.">
                                        <feather-icon  icon="DollarSignIcon" svgClasses="w-5 h-5 hover:text-success stroke-current cursor-pointer" class="ml-6" @click.stop="requestReminder(data[indextr], 2)" />
                                    </vx-tooltip> -->
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>

        <vs-popup
            :title="isEditing ? 'Editar accionista' : 'Agregar accionista'"
            :active.sync="showFormPrompt">
            <stakeholder-form 
                ref="stakeholderForm" 
                :stakeholder="selectedStakeholder" 
                :repLegalIsMainUser="false" 
                :hasMoreThanFourStakeholders="false"
                :isEditing="isEditing"
                :collections="collections"
                @updated="stakeholderUpdated"
            ></stakeholder-form>
      </vs-popup>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js";
import dateHelper from "@mixins/dateHelper.js";
import StakeholderForm from "./StakeholderForm.vue"

const columnDefinitions = [
  { title: "ID", key: "complete_name", sortable: true },
  { title: "DIRECCIÓN", key: "address", sortable: true },
//   { title: "NOMBRE", key: "name", sortable: true },
//   { title: "RFC", key: "rfc", sortable: true },
//   { title: "EMAIL", key: "email", sortable: true },
//   { title: "TEL", key: "email", sortable: true },
//   { title: "TELÉFONO", key: "phone", sortable: true },
  { title: "% ACCIONES", key: "participation", sortable: true },
  { title: "FECHA*", key: "date", sortable: true },
  { title: "GID", key: "gid", sortable: true },
  { title: "¿Es RepLegal?", key: "date", sortable: true },
  { title: "¿Es OS?", key: "date", sortable: true },
  { title: "ACCIONES", key: "", sortable: false },
];

export default {
    name: "StakeholdersControl",
    mixins: [formatHelper, dateHelper],
    props: {
        source: Object
    },
    components: {
        StakeholderForm
    },
    data: () => ({
        columns: columnDefinitions,
        selectedStakeholder: null,
        isEditing: false,
        showFormPrompt: false,
        stakeholdersArray: [],
        isMounted: false,
        collections: {
            countries: []
        },
    }),
    computed: {
        business() {
            return this.source.client.user.business;
        },
        personal_business() {
            return this.business.personal;
        },
        stakeholders() {
            return this.business.stakeholders
        }
    },
    async mounted() {
        this.isMounted = false;
        await this.getCollections();
        await this.setStakeholdersForAdmin();
        this.isMounted = true;
    },
    methods: {
        async getCollections(){
            try {
                let collectionsObjects = ['countriesList'];
                let params = "with[]=" + collectionsObjects.join("&with[]=");
                let res = await this.publicApiGet(`/api/v1/forms/getPublicFormCollections?${params}`);
                let colls = res.data;
                colls.countriesList.forEach(opt => {
                    this.collections.countries.push({value: parseInt(opt.id), label: opt.name}); //conversion a sintaxis de vx-select
                });
            }
            catch (e) {
            }
        },
        setStakeholdersForAdmin() {
            this.stakeholdersArray = [];
            this.stakeholders.forEach(st => {
                st.is_guarantee = (this.getGuaranteeData(st.guarantee_data) != null);
                st.guarantee_id = this.getGuaranteeData(st.guarantee_data) != null ? this.getGuaranteeData(st.guarantee_data).guarantee_id : null
                this.stakeholdersArray.push(st);
            });
        },
        setEditForm(tr) {
            const isMoral = tr.stakeholder_bp_id != null;
            const isValid = tr.stakeholder_bp_id != null || tr.stakeholder_pp_id != null
            this.selectedStakeholder = {
                role_type: "Accionista",
                role: "stakeholder",
                profile: {
                    first_name: null,
                    second_name: null,
                    last_name_1: null,
                    last_name_2: null,
                    curp: null,
                    rfc: null,
                    birth_date: null,
                    citizenship: 700,
                    phone: {
                        phone: null,
                        country_calling_code: "+52",
                    },
                    phone_id: null,
                },
                share_percentage: tr.share_percentage * 10,
                role_type: 2,
                email: null,
                person_type: null,
                isValid: true,
                is_max_percentage: null,
                id: tr.id,
                loan_id: this.source.id
                
            };
            if(isValid) {
                if(isMoral) {
                    // console.log(tr);
                    this.selectedStakeholder.profile.name = tr.business_profile.name;
                    this.selectedStakeholder.profile.rfc = tr.business_profile.rfc;
                    this.selectedStakeholder.email = tr.email 
                    this.selectedStakeholder.profile.constitution_date = tr.business_profile.constitution_date;
                    this.selectedStakeholder.profile.phone_id = tr.business_profile.phone_id;
                    if(tr.business_profile.phone_id != null) {
                        this.selectedStakeholder.profile.phone = {
                            phone: tr.business_profile.phone.phone,
                            country_calling_code: tr.business_profile.phone.country_calling_code,
                        }
                    }
                    this.selectedStakeholder.person_type = "2";
                } else {
                    this.selectedStakeholder.profile.first_name = tr.personal_profile.first_name;
                    this.selectedStakeholder.profile.second_name = tr.personal_profile.second_name;
                    this.selectedStakeholder.profile.last_name_1 = tr.personal_profile.last_name_1;
                    this.selectedStakeholder.profile.last_name_2 = tr.personal_profile.last_name_2;
                    this.selectedStakeholder.person_type = "1";
                    this.selectedStakeholder.email = tr.email                
                    this.selectedStakeholder.profile.birth_date = tr.personal_profile.birth_date;
                    this.selectedStakeholder.profile.citizenship = tr.personal_profile.citizenship;
                    this.selectedStakeholder.profile.phone_id = tr.personal_profile.phone_id;
                    if(tr.personal_profile.phone_id != null) {
                        this.selectedStakeholder.profile.phone = {
                            phone: tr.personal_profile.phone.phone,
                            country_calling_code: tr.personal_profile.phone.country_calling_code,
                        }
                    }
                }
                this.isEditing = true;
                this.showFormPrompt = true;
            } else {
                this.missingFieldsNotif(null, "Este accionista se creó de manera erronea, sugiero eliminar.");
            }
        },
        addStakeholder() {
            this.selectedStakeholder = {
                role_type: "Accionista",
                role: "stakeholder",
                profile: {
                    first_name: null,
                    second_name: null,
                    last_name_1: null,
                    last_name_2: null,
                    curp: null,
                    rfc: null,
                    birth_date: null,
                    citizenship: 700,
                    phone: {
                        phone: null,
                        country_calling_code: "+52",
                    },
                    phone_id: null,
                },
                share_percentage: null,
                role_type: null,
                email: null,
                person_type: null,
                isValid: true,
                is_max_percentage: null,
                id: null,
                loan_id: this.source.id
                
            };
            this.showFormPrompt = true;
        },
        async stakeholderUpdated() {
            // console.log("stakeholderUpdated")
            this.showLoading(true);
            this.isMounted = false;
            this.stakeholdersArray = [];
            this.addStakeholder();
            this.isEditing = false;
            this.showFormPrompt = false;
            await this.$emit("updated");
            setTimeout(() => {
                this.setStakeholdersForAdmin();
            }, 3000);
            this.isMounted = true;
            this.$forceUpdate();
            this.showLoading(false);
            // console.log("stakeholderUpdated111")
        },
        personType(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return "PM";
            } else if(stakeholder.stakeholder_pp_id != null) {
                return "PF";
            } else {
                "NO TIENE PERFIL"
            }
        },
        stakeholderName(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return stakeholder.business_profile.name;
            } else if(stakeholder.stakeholder_pp_id != null) {
                const personal = stakeholder.personal_profile; 
                return `${personal.first_name} ${personal.second_name||""} ${personal.last_name_1} ${personal.last_name_2||""}`;
            } else {
                "NO TIENE PERFIL"
            }
        },
        getRFC(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return stakeholder.business_profile.rfc;
            } else if(stakeholder.stakeholder_pp_id != null) {
                const personal = stakeholder.personal_profile; 
                // console.log(personal)
                return personal.rfc||"--";
            } else {
                "NO TIENE PERFIL"
            }
        },
        getDate(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return this.humanizedCompactDate(stakeholder.business_profile.constitution_date);
            } else if(stakeholder.stakeholder_pp_id != null) {
                const personal = stakeholder.personal_profile; 
                return this.humanizedCompactDate(personal.birth_date);
            } else {
                "NO TIENE PERFIL"
            }
        },
        getPhone(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return this.phoneFormat(stakeholder.business_profile.new_phone);
            } else if(stakeholder.stakeholder_pp_id != null) {
                const personal = stakeholder.personal_profile; 
                return this.phoneFormat(personal.new_phone);
            } else {
                "NO TIENE PERFIL"
            }
        },
        getAddress(stakeholder) {
            if(stakeholder.stakeholder_bp_id != null) {
                return stakeholder.business_profile.address;
            } else if(stakeholder.stakeholder_pp_id != null) {
                const personal = stakeholder.personal_profile; 
                return personal.address
            } else {
                "NO TIENE PERFIL"
            }
        },
        getGuaranteeData(stakeholder) {
            const data = stakeholder.find(x => x.loan_id == this.source.id);
            if(data != null) {
                return data;
            } else {
                return null;
            }
        },
        canDelete(tr) {
            return !tr.is_guarantee;
        },
        removeItemRequest(testimony){
            this.selectedStakeholder = testimony;

            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Eliminar Accionista',
                text: `¿Realmente desea eliminar al accionista ${this.stakeholderName(testimony)}?`,
                acceptText: "Eliminar",
                cancelText: 'Cancelar',
                accept: this.doRemoveItem
            });
        },
        async doRemoveItem(){
            this.showLoading(true);
            try {
                await axios.delete(`/api/stakeholder/delete/${this.selectedStakeholder.id}/stakeholder`);
                this.$emit("updated");
            }
            catch (error) {
                this.showLoading(false);
                this.failedOperationNotif();
                console.log(error);
                // this.warn(error);
            }
            this.showLoading(false);
        },
        isRepLegal(tr) {
            const ppId = this.personal_business.id;

            return tr.stakeholder_pp_id == ppId;
        },
        async receiveCallHandle(reference) {
            this.selectedStakeholder = reference;
            let title = "";
            let mssg = "";
            if(!this.selectedStakeholder.is_guarantee) {
                title = 'Eliminar como Obligado solidario';
                mssg = `¿Realmente desea eliminar como Obligado solidario al accionista ${this.stakeholderName(reference)}?`;
            } else {
                title = 'Seleccionar como Obligado solidario';
                mssg = `¿Realmente desea agregar como Obligado solidario al accionista ${this.stakeholderName(reference)}?`;
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: title,
                text: mssg,
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doChangeStakerholder
            });
        },
        async doChangeStakerholder() {
            this.showLoading(true);
    
            try {
                const payload = {
                    event: this.selectedStakeholder.is_guarantee,
                    project_id: this.source.id,
                    guarantee_id: this.selectedStakeholder.guarantee_id,
                    person_type: this.selectedStakeholder.person_type
                };
    
                // console.log(payload);
                await axios.post(`/api/stakeholder/post/${this.selectedStakeholder.id}/set-as-guarantee`, payload)
                await this.$emit("updated");
                setTimeout(() => {
                    this.setStakeholdersForAdmin();
                }, 7000);
                this.showLoading(false);
            } catch (e) {
                this.errorNotif('Error', 'Ha ocurrido un error al actualizar la referencia')
                this.showLoading(false);
            }
        },
        async requestReminder(stakeholder, flow) {
            try {
                this.showLoading(true);
                const response = await axios.post(`/api/guarantee/post/${stakeholder.guarantee_id}/send-reminder/${flow}`);
                this.showLoading(false);
                this.showGuaranteeAlert(flow);
            } catch (error) {
                this.showLoading(false);
                this.$vs.notify({
                    title: 'Error',
                    text: 'Ocurrió un error al obtener la información',
                    color: 'danger',
                    position: 'top-right'
                });
            }
        },
        showGuaranteeAlert(flow) {
            const text = flow == 1 ? "verifique su identidad" : "autorización para consultar su historial crediticio";
            this.$vs.dialog({
                color: 'success',
                title: 'Notificaremos al obligado solidario.',
                text: `Enviamos un correo al Obligado Solidario en donde se le solicitará la ${text}.
                        \n Por favor comunícate con el/ella para que no se extrañe de este correo y nos ayude en el proceso de solicitud de crédito.`,
                acceptText: "Continuar",
            });
        },
    }
}
</script>